import { Currency, FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { QueryBuilder } from '../QueryBuilder';
import { MetricFilter } from './MetricFilter';

export class CurrencyFilter extends MetricFilter<Currency> {
  public field = 'currency';
  public operator = FilterOperator.IN;

  constructor(currencies?: Currency[]) {
    super(currencies);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    const newFilter = newQueryBuilder.metricFilter<CurrencyFilter>(this);
    if (this.areValuesIncluded(newFilter)) return false;
    return true;
  }

  public merge(newFilter: CurrencyFilter): this {
    if (!(newFilter instanceof CurrencyFilter)) return this;
    if (newFilter.values === undefined) return new CurrencyFilter(undefined) as this;
    if (this.areValuesIncluded(newFilter)) return this;
    const uniqueValues = Array.from(new Set([...this.values, ...newFilter.values]));
    return new CurrencyFilter(uniqueValues) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    if (!this.values) return metrics;
    return metrics.filter((metric) => this.values.some((value) => value === metric.currency));
  }
}
